"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lodash = require("lodash");

function choose() {
  return {
    name: 'choose',
    synopsis: 'choose [CHOICE] ...[CHOICES]',
    description: 'Choose one or more values from multiple choices',
    options: {
      n: {
        alias: 'number',
        description: 'Take n choices',
        type: 'number',
        default: 1,
        valid: function valid(value, args) {
          return value > 0 && value <= args.length;
        }
      }
    },
    format: function format(choices) {
      return choices.join(' ');
    },
    execute: function execute(args, opts) {
      return (0, _lodash.take)((0, _lodash.shuffle)(args), opts.number);
    }
  };
}

var _default = choose;
exports.default = _default;